























































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Modal extends Vue {
  private openBtn!: HTMLElement;

  private closeBtn!: HTMLElement;

  @Prop({ default: 'Cancelar' })
  private cancelButton!: string | boolean;

  @Prop({ default: 'Enviar' })
  private sendButton!: string;

  @Prop({ default: 'Modal' })
  public header!: string;

  @Prop({ required: true })
  public name!: string;

  public open() {
    this.openBtn.click();
  }

  public close() {
    this.closeBtn.click();
  }

  private mounted() {
    this.openBtn = this.$refs.open as HTMLElement;
    this.closeBtn = this.$refs.close as HTMLElement;
  }

  private confirm() {
    this.$emit('confirm');
  }

  private cancel(triggerAction = false) {
    this.$emit('cancel', triggerAction);
  }
}
